<div class="content-layout right-sidebar-fullheight-basic-inner-scroll">
  <div class="main p-0">
    <div class="list-wrapper">
      <header class="header">
        <!-- Title -->
        <section class="header__title">
          <h1 class="m-0">Task List Templates</h1>
          <div class="font-medium">
            <ng-container *ngIf="taskListTemplatesCount > 0">
              {{ taskListTemplatesCount }}
              {{
                taskListTemplatesCount
                  | i18nPlural
                    : {
                        '=0': 'No templates',
                        '=1': 'template',
                        other: 'templates',
                      }
              }}
            </ng-container>
          </div>
        </section>

        <!-- Main actions -->
        <section class="header__main-actions">
          <button
            mat-flat-button
            [color]="'primary'"
            (click)="createNewTemplate()"
            data-testid="create-template-button"
          >
            <mat-icon [svgIcon]="'add'"></mat-icon>
            <span>Create Template</span>
          </button>
        </section>
      </header>

      <ng-container *ngIf="dataSource; else TaskTemplatesLoading">
        <ng-container *ngIf="dataSource.data.length; else NoTasksListTemplate">
          <div class="templates-list">
            <table
              mat-table
              matSort
              [matSortActive]="'name'"
              [matSortDisableClear]="true"
              [matSortDirection]="'asc'"
              [dataSource]="dataSource"
              [trackBy]="trackByFn"
              data-testid="templates-table"
            >
              <ng-container matColumnDef="name">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>Name</th>
                <td
                  mat-cell
                  *matCellDef="let taskListTemplate"
                  [attr.data-testid]="'template-name-' + taskListTemplate.id"
                >
                  <div class="name-content">
                    <span class="name"
                      ><a [routerLink]="['./' + taskListTemplate.id]">{{ taskListTemplate.name }}</a></span
                    >
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="applicable_type">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>Applicable Type</th>
                <td
                  mat-cell
                  *matCellDef="let taskListTemplate"
                  [attr.data-testid]="'template-type-' + taskListTemplate.id"
                >
                  {{ getRelatedToType(taskListTemplate.applicable_type) }}
                </td>
              </ng-container>

              <ng-container matColumnDef="created_at">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>Created</th>
                <td
                  mat-cell
                  *matCellDef="let taskListTemplate"
                  [attr.data-testid]="'template-created-' + taskListTemplate.id"
                >
                  {{ taskListTemplate.created_at | date: 'MMM dd, y' }}
                </td>
              </ng-container>

              <ng-container matColumnDef="updated_at">
                <th mat-header-cell mat-sort-header *matHeaderCellDef>Last Updated</th>
                <td
                  mat-cell
                  *matCellDef="let taskListTemplate"
                  [attr.data-testid]="'template-updated-' + taskListTemplate.id"
                >
                  {{ taskListTemplate.updated_at | date: 'MMM dd, y' }}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="taskListTemplatesTableColumns; sticky: true"></tr>

              <tr
                class="template-row"
                mat-row
                *matRowDef="let taskListTemplate; columns: taskListTemplatesTableColumns"
                [attr.data-testid]="'template-row-' + taskListTemplate.id"
              ></tr>
            </table>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #NoTasksListTemplate>
  <section class="no-templates w-full h-full flex flex-col justify-center items-center">
    <img class="no-templates__image" src="assets/images/empty_list.svg" alt="No Records Found" />
    <h5 class="mt-0 text-center">Looks like you haven't created any task list template yet.</h5>
    <h5 class="m-0 text-center">Click on the 'Create Template' button above to create one.</h5>
  </section>
</ng-template>

<ng-template #TaskTemplatesLoading>
  <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
</ng-template>
